import * as React from 'react'

import { Box, CardInfo, Text } from '@factorialco/deprecated-design-system'
import { EmployeeCustomTablesSchemaFragment } from 'generated/resources/graphql'
import sortBy from 'lodash/sortBy'

import i18n from 'modules/core/lib/i18n'

import type Resource from 'modules/custom_resources/store/models/customResources/Resource'
import type Value from 'modules/custom_resources/store/models/customResources/Value'

import List from './_List'

interface Props {
  schemas: EmployeeCustomTablesSchemaFragment[]
  resources: Resource[]
  values: Value[]
  attachableId: number
  attachableType: string
  currency: string
  canManage: boolean
  canAddCustomTableRecords: boolean
}

const CustomTablesList = ({
  schemas,
  resources,
  values,
  attachableId,
  attachableType,
  currency,
  canManage,
  canAddCustomTableRecords,
}: Props) => {
  const refs = schemas.map(() => React.createRef<HTMLElement>())

  const sortedSchemas = sortBy(schemas, (schema) => schema.position)

  return (
    <Box flexGrow flexDirection="column" paddingY="s32" paddingRight="s48">
      {sortedSchemas.length > 0 && (
        <List
          attachableId={attachableId}
          attachableType={attachableType}
          resources={resources}
          schemaRefs={refs}
          schemas={sortedSchemas}
          currency={currency}
          values={values}
          canManage={canManage}
          canAddValues={canAddCustomTableRecords}
        />
      )}
      {sortedSchemas.length === 0 && (
        <CardInfo>
          <Box flexDirection="row" justifyContent="center" flexGrow>
            <Text.Normal>{i18n.t('custom_tables.none')}</Text.Normal>
          </Box>
        </CardInfo>
      )}
    </Box>
  )
}

export default CustomTablesList
